<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>离职率考核</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">店员离职</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{ formatDate(form.quitEndTime) }} <span class="gorequset" @click="goProcess">去处理</span></div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>客诉</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{formatDate(form.complainEndTime)}}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>品质站考核</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{formatDate(form.qualityEndTime)}}</div>
            </div>
            <div class="color999">以上类型的绩效工资金额以后台审核结果为准，如果您已经提交申请但是金额不准确，请联系后台人员协助处理。</div>
          </div>
          <div class="drawer-footer pr24 pb10">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "申诉",
      form: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.userInfo = this.$store.getters.ShopInfo;
        this.getAppealInfo(org);
        this.addEditShow = true;
      });
    },
    getAppealInfo(org){
      this.$api.get(this.$url.staffKpiSalary.getAppealInfo,{
        reportMonth: org,
      })
        .then(res => {
          this.form = res;
        })
        .catch(error => {});
    },
    goProcess () {
      this.$router.push("/manage/companyRecode");
      this.$store.commit("setCurentUrls", "/dataList/attendancePunch");
      // sessionStorage.setItem("goBack", "/dataList/staffKPISalary");
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.gorequset {
  padding: 0 5px;
  color: #3388FF;
  border: 1px solid #3388FF;
  border-radius: 2px;
  cursor: pointer;
}
</style>